<div class="modal">
    <div class="modal__header d-flex jc-flex-end">
        <button class="btn-close" type="button" (click)="closeModal()"><span class="btn-close__icon icon-close"></span></button>
    </div>
    <div class="modal__body">
        <h2 class="mt-none text-center text-mid px-mid">Agenda la visita para tus fotos 360°</h2>

        <p class="text-center">Escoge la hora y la fecha para la toma de las fotografías.</p>

        <form class="mt-half" [formGroup]="appointmentForm">
            <mat-form-field appearance="outline" class="width-100 mat-form-field--blue">
                <mat-label>Adquirir fotos 360</mat-label>
                <input matInput type="text" formControlName="photoNumber" placeholder="10">
                <mat-icon matSuffix class="text-complementary-two">image</mat-icon>
                <mat-error>Este campo es <strong>requerido</strong></mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="width-100 mat-form-field--blue">
                <mat-label>Fecha de visita</mat-label>
                <input matInput type="date" formControlName="date" placeholder="12 / 06 / 2020">
                <mat-error>Este campo es <strong>requerido</strong></mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="width-100 mat-form-field--blue">
                <mat-label>Selecciona el horario</mat-label>
                <input matInput type="time" formControlName="time" placeholder="10 : 36">
                <mat-error>Este campo es <strong>requerido</strong></mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="width-100 mat-form-field--blue">
                <mat-label>Dirección dónde se recogerán las llaves</mat-label>
                <input matInput type="text" formControlName="address" placeholder="Cr 54 # 128 A">
                <mat-icon matSuffix class="text-complementary-two">home</mat-icon>
                <mat-error>Este campo es <strong>requerido</strong></mat-error>
            </mat-form-field>
        </form>

        <div class="d-flex jc-center my-half">
            <button class="button rounded secondary px-large py-thumb text-small" type="button">AGENDAR VISITA</button>
        </div>
    </div>

</div>